angular.module('vastdesk').
  component('demandForecast',  {
    bindings: {
      forecastObject: "<",
      isDemandReservationsEnabled: "<"
    },
    template: '',
    controllerAs: '$demandForecastCtrl',
    controller: ['$scope', '$rootScope', function($scope, $rootScope) {
      /** @type {"uninitialized" | "fetching" | "success" | "error"} */
      this.forecastQueryState = 'uninitialized';

      $scope.$watch('$demandForecastCtrl.forecastQueryState', (newState, _oldState) => {
        $('#run_forecast').prop('disabled', ('fetching' === newState));
      });

      this.$onInit = () => {
        getForecastData();
      }

      const getForecastData = () => {
        const url = `/forecasting/demand/${this.forecastObject.id}/data.json`;
        this.forecastQueryState = 'fetching';
        $.get({
          url: url,
          success: (resp) => {
            if (resp) {
              displayForecastData(resp);
            } else {
              // I don't know why we wouldn't have a response body,
              // but, we don't want to keep the Run Forecast button
              // disabled if the request for forecast data broke
              this.forecastQueryState = 'success';
            }
            // trigger an AngularJS digest to allow `$scope.$watch` to work
            setTimeout(() => $scope.$digest(), 10);
          }, error: (resp) => {
            this.forecastQueryState = 'error';
            if (resp) {
              displayForecastRequestInfo(getErrorText(resp.responseText), 'error')
            }
            // trigger an AngularJS digest to allow `$scope.$watch` to work
            setTimeout(() => $scope.$digest(), 10);
          }
        });
      }

      const displayForecastData = (data) => {
        if (data.status === 'completed') {
          this.forecastQueryState = 'success';
          const updateForecastCells = (table, cellsData) => {
            cellsData.forEach(([selector, value]) => {
              let text = "N/A";
              if (typeof value !== "undefined" && value !== null) {
                text = value.toLocaleString();
              }
              table.find(selector).text(text);
            });
          };
          if (!this.isDemandReservationsEnabled ||
            data.request?.tier === null ||
            !data.request?.budget ||
            data.request?.supply_tag_ids?.values?.length > 500 ||
            ( // No objects = RON
              !data.request?.supply_tag_ids &&  //returned when sending tags, partners, or labels
              !data.request?.supply_router_ids  //returned when sending routers
            )) {
            const forecastTable = $(".forecast-display-table-simple");
            updateForecastCells(forecastTable, [
              [".ad-requests", data.total_requests],
              [".total-impressions", data.total_impressions]
            ]);
            forecastTable.toggleClass('hidden');
          } else {
            const forecastTable = $(".forecast-display-table-advanced");
            updateForecastCells(forecastTable, [
              [".ad-requests", data.total_requests],
              [".total-impressions", data.total_impressions],
              [".available-impressions", data.total_available_impressions],
              [".reserved-impressions", data.total_reserved_impressions],
              [".over-reserved", data.total_over_reserved_impressions],
              [".likely-to-deliver", data.total_likely_to_deliver_impressions],
              [".unlikely-to-deliver", data.total_unlikely_to_deliver_impressions]
            ]);
            forecastTable.toggleClass('hidden');
          }
          $("span#forecast-request-info").attr('class', 'hidden');
        } else if (data.status === 'querying' || data.status === 'forecasting') {
          this.forecastQueryState = 'fetching'
          // Poll again after 5 seconds
          setTimeout(getForecastData, 5000);
          displayForecastRequestInfo(data.status, '');
        } else {
          this.forecastQueryState = 'error';
          displayForecastRequestInfo(`${getErrorText(data.error)}`, 'error');
        }
      }

      const getErrorText = (error) => {
        const defaultErrorText = 'Error processing forecast. Please try again after 10 minutes.'
        
        if (!error || typeof error !== 'string') {
          return defaultErrorText;
        }
        
        const errorLower = error.toLowerCase();
        
        if (errorLower.includes('no forecast from mfe')) {
          return 'No forecast from MFE. Likely not enough data.';
        } else if (errorLower.includes("sketch api error") && errorLower.includes("'code': '500'")) {
          return 'Error processing forecast. We have been alerted and are investigating.';
        }
        return defaultErrorText;
      }

      const displayForecastRequestInfo = (displayData, classList) => {
        const statusSpan = $("span#forecast-request-info");
        statusSpan.text("Forecast Status: " + displayData);
        statusSpan.attr('class', classList);
      }
    }]
});
